export class TranslationTexts{

    /**
     * 
     * Don't define translation strings everywhere in the client.
     * Use something like this to make it easier for both you and the translator to know what text are being used.
     * 
    */

    // WIN, number of  RoadRage
    public static WAYS:string = "WAYS";
    public static WAYS_WON:string = "Ways Won";
    public static WAY_WON:string = "Way Won";

    public static WIN_UP_TO:string = "WIN UP TO";

    // OUTRO TOTAL WIN
    public static TOTAL_WIN:string = "TOTAL WIN";

    // SUMMARY TOTAL WIN
    public static SETUP_SUMMARY:string = "SUMMARY";
    public static SETUP_CARS_UPGRADED:string = "CARS UPGRADED";
    public static SETUP_FREESPINS_WON:string = "FREESPINS WON";

    // TOTAL WIN.
    public static _LVL:string = " LEVEL"; 

    // BUTTON TEXT
    public static LOADING:string = "LOADING";
    public static CONTINUE:string = "CONTINUE";

    // SPLASH SCREENS
    public static CONGRATULATIONS:string = "CONGRATULATIONS!";
    public static YOU_WON:string = "YOU WON";

    public static FREESPINS:string = "MORNING RUSH SPINS"; // 3 Scatter
    public static FREESPINS_SUPER:string = "HIGHWAY STOP SPINS"; // 4 Scatter
    public static FREESPINS_UBER:string = "CITY JAM SPINS"; // 5 Scatter

    public static FREESPINS_PLAYED:string = "SPINS PLAYED:";
    public static FREESPINS_LEFT:string = "SPINS LEFT";

    public static COLLECT:string = "COLLECT";
    public static REMOVE_SYMBOLS:string = "REMOVE SYMBOLS";

    public static LAST_SPIN:string = "LAST SPIN!!!";

    public static RESPIN_TRIGGER:string = "Respin";

}
